import type { FC } from 'react';
import React from 'react';

import type { LinkType, OnboardLinkFormProps } from '../../link/types';
import { CreateCustomLinkForm } from '../../link/CreateCustomLinkForm';
import { OnboardIncreaseLinkForm } from '../../link/OnboardIncreaseLinkForm';
import { OnboardStripeLinkForm } from '../../link/OnboardStripeLinkForm';
import { OnboardUnitLinkForm } from '../../link/OnboardUnitLinkForm';

const routes: Record<LinkType, FC<OnboardLinkFormProps>> = {
  IncreaseLink: OnboardIncreaseLinkForm,
  CustomLink: CreateCustomLinkForm,
  UnitLink: OnboardUnitLinkForm,
  StripeLink: OnboardStripeLinkForm,
};

export type Props = {
  linkType: LinkType;
  onCreate: VoidFunction;
};
export const AddLinkView = ({ linkType, onCreate }: Props) => {
  const Component = routes[linkType];
  return (
    <Component
      {...{
        onCreate,
      }}
    />
  );
};
